package com.example.mystybag.common.ui.components.native

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import com.example.mystybag.common.ui.components.native.Texts.ClickableTextView
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.model.LinkModel
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p28
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.painterResource

@Composable
fun CheckBoxLink(
    texts           : List<LinkModel>,
    checked         : Boolean,
    vAlignment      : Alignment.Vertical    = Alignment.CenterVertically,
    modifier        : Modifier              = Modifier,
    textStyle       : TextStyle             = AppTheme.current.typography.bodyLarge,
    onTextClick     : ((Int) -> Unit)?      = null,
    onCheckBoxClick : (() -> Unit)?         = null
) {
    Row(
        verticalAlignment = vAlignment,
        modifier = modifier.fillMaxWidth()
    ) {
        Image(
            painter = painterResource(
                when {
                    checked -> SRC.images.checkbox_clicked
                    PlatformHelper.isWeb -> SRC.images.checkbox_not_clicked_web
                    else -> SRC.images.checkbox_not_clicked
                }
            ),
            contentDescription = null,
            modifier = Modifier
                .padding(end = p16)
                .size(p28)
                .clickable(
                    interactionSource = MutableInteractionSource(),
                    indication = null
                ) { onCheckBoxClick?.invoke() }
        )
        ClickableTextView(
            texts       = texts,
            textStyle   = textStyle,
            modifier    = Modifier.fillMaxWidth(),
            onItemClick = onTextClick
        )
    }
}

/*@Preview
@Composable
fun CheckBoxLinkPreview() {
    val checkBoxState = remember { mutableStateOf(false) }
    val data = listOf(LinkModel("I agree to " ,""), LinkModel("General terms", "https://abv.bg"), LinkModel(", " , ""), LinkModel("Fees" , "https://dir.bg"),LinkModel( " and " , ""),LinkModel( "Limits" , "https://dnes.bg"))
    AppTheme.setup(false)
    AppThemeView {
        Column(modifier = Modifier.background(AppTheme.current.colors.background).padding(p2XS)) {
            CheckBoxLink(
                texts = data,
                state = checkBoxState
            )
        }
    }
}*/